/**
 * © 2024 Little Shilling, Inc.
 * Shon Little
 * Created: 2024-08-07
 */

// Add third-party dependencies.
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Create the employSlice.
export const employSlice = createApi({
  reducerPath: 'employApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API,
    prepareHeaders: (headers) => {
      // Get the access token from localStorage.
      const token = localStorage.getItem('accessToken');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  // Add endpoints here.
  tagTypes: ['payrates', 'activities'],
  endpoints: (builder) => ({
    getRates: builder.query({
      query: () => 'timesheet/payrates/',
      providesTags: ['payrates'],
    }),
    getActivities: builder.query({
      query: () => '/timesheet/activities/',
      providesTags: ['activities'],
    }),
    addActivity: builder.mutation({
      query: (newActivity) => ({
        url: 'timesheet/activities/',
        method: 'POST',
        body: newActivity,
      }),
      invalidatesTags: ['activities'],
    }),
    updateActivity: builder.mutation({
      query: ({ id, ...updateActivity }) => ({
        url: `timesheet/activities/${id}/`,
        method: 'PUT',
        body: updateActivity,
      }),
      invalidatesTags: ['activities'],
    }),
    deleteActivity: builder.mutation({
      query: (id) => ({
        url: `timesheet/activities/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['activities'],
    }),
  }),
});

// Export the auto-generated hooks.
export const {
  useGetRatesQuery,
  useGetActivitiesQuery,
  useAddActivityMutation,
  useUpdateActivityMutation,
  useDeleteActivityMutation,
} = employSlice;
